export const TEMP_DASHBOARD_UNIVERSAL_ALLOWED_USERS = [
  '100719',
  '100744',
  '100754',
  '100831',
  '100917',
  '100926',
  '100929',
  '100931',
  '100982',
  '101030',
  '101229',
  '101567',
  '101858',
  '101878',
  '101924',
  '101930',
  '102213',
  '104786',
  '104787',
  '104788',
  '104789',
  '104790',
  '104791',
  '104840',
  '104842',
  '104848',
  '104849',
  '104850',
  '104852',
  '104860',
  '104862',
  '104864',
  '104865',
  '104866',
  '104867',
  '104868',
  '104870',
  '104872',
  '104873',
  '104874',
  '104875',
  '105156',
  '105291',
  '105292',
  '105440',
  '105520',
  '105651',
  '105652',
  '105691',
  '107300',
  '107417',
  '107418',
  '108177',
  '108271',
  '109765',
  '109781',
  '109782',
  '109975',
  '110638',
  '110879',
  '110890',
  '110899',
  '110917',
  '110919',
  '110937',
  '110938',
  '110939',
  '111886',
  '112026',
  '112049',
  '112087',
  '112088',
  '112105',
  '112130',
  '112494',
  '112495',
  '112497',
  '112936',
  '112937',
  '113413',
  '113598',
  '113599',
  '113781',
  '114893',
  '114894',
  '114968',
  '114970',
  '114975',
  '115664',
  '115665',
  '115667',
  '115904',
  '115907',
  '115909',
  '115919',
  '115926',
  '115956',
  '115957',
  '116610',
  '116614',
  '117031',
  '117036',
  '117055',
  '117056',
  '117057',
  '117058',
  '117130',
  '117470',
  '117535',
  '117564',
  '117777',
];
